import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { GhostButton } from 'ui/button';

export const ActionCellContainer = styled.div`
  display: flex;
  flex: 1 1 25%;
  align-items: flex-start;
  transition: background 0.2s, opacity 0.2s;
  padding: 0 ${pxToRem(8)} 0 0;
  opacity: 0;
  [data-role='cell']:first-child &,
  [data-role='header-cell']:first-child & {
    justify-content: center;
  }
  [data-role='cell'] > & {
    margin: -${pxToRem(6)} ${pxToRem(8)} -${pxToRem(6)} -${pxToRem(8)};
  }
  [data-role='row'] > [data-role='cell']:first-child > & {
    border: ${pxToRem(1)} solid #fff;
    border-left-color: transparent;
    border-right-color: transparent;
    z-index: 1;
  }
  [data-role='row']:hover > [data-role='cell'] & {
    opacity: 1;
  }
  [data-role='header'] + [data-role='row'] > [data-role='cell']:first-child > & {
    margin-top: -${pxToRem(5)};
  }
  [data-role='toolbar']
    + [data-role='table']
    [data-role='header']
    + [data-role='row']
    > [data-role='cell']:first-child
    > & {
    border-top: 0;
  }
  [data-role='row']:last-child > [data-role='cell']:first-child > & {
    border-bottom: 0;
  }
  [data-role='header-cell'] > & {
    color: #717171;
  }
  [data-role='header-cell']:first-child > & {
    border: ${pxToRem(1)} solid transparent;
    border-left: 0;
    border-top: 0;

    [data-role='toolbar'] + [data-role='table'] > [data-role='body'] & {
      border: 0;
    }
  }
  &[data-number-of-actions='1'] {
    min-width: ${pxToRem(40)};
    max-width: ${pxToRem(40)};
  }
  &[data-number-of-actions='2'] {
    min-width: ${pxToRem(90)};
    max-width: ${pxToRem(90)};
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  text-align: center;
`;

export const StyledGhostButton = styled(GhostButton)`
  height: ${pxToRem(20)};
  > .icon {
    margin: 0;
  }
`;
